import './index.css'
import * as React from 'react'
import { connect } from 'react-redux'
import type { Group, GroupId } from 'types/group'
import type { State } from 'types/redux'
import { loadGroups } from '@disco/state-management/actions/GroupActions'
import { getInboxes } from '@disco/state-management/selectors/groups'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import { DropdownOption } from 'types/ui'

function mapStateToProps(state: State) {
  return {
    groups: getInboxes(state).map(g => ({
      label: g.name,
      value: g.id,
    })),
  }
}

const mapDispatchToProps = {
  loadGroups,
}

class InboxSelect extends React.Component<{
  groups: DropdownOption[]
  value: GroupId | null | undefined
  loadGroups: typeof loadGroups
  onChange: (value: GroupId | null | undefined) => unknown
}> {
  componentDidMount() {
    this.props.loadGroups()
  }

  render() {
    return (
      <CustomDropdown
        options={this.props.groups}
        placeholder="Choose inbox"
        value={this.props.value}
        onChange={this.props.onChange}
      />
    )
  }
}

// @ts-expect-error type connector
export default connect(mapStateToProps, mapDispatchToProps)(InboxSelect) as any
